import { makeAutoObservable } from 'mobx'
import { $RootStore } from './RootStore'
import { NavigateFunction } from 'react-router'

class NavigationStore {
  rootStore: $RootStore
  remixNavigate: NavigateFunction | undefined
  pathname = ''

  constructor(rootStore: $RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  navigate = (_route: string, _options?: any) => {
    alert('No navigation function set in NavigationStore')
  }

  unsupported_navigate = (route: string, _options?: any) => {
    if (this.remixNavigate) {
      this.remixNavigate(route)
    } else {
      alert('No navigation function set in NavigationStore')
    }
  }

  setSearchParams = (params: Record<string, string>) => {
    const currentParams = new URLSearchParams(window.location.search)

    for (const key in params) {
      currentParams.set(key, params[key])
    }

    this.unsupported_navigate(`?${currentParams.toString()}`)
  }

  openURL = (link: string) => {
    window.open(link, '_blank')?.focus()
  }

  setNavigation(navigate: NavigateFunction) {
    this.remixNavigate = navigate
  }
}

export default NavigationStore